//営業日カレンダー
document.addEventListener('DOMContentLoaded', function() {
    var calendarEl = document.getElementById('calendar');
    var calendar = new FullCalendar.Calendar(calendarEl, {
      googleCalendarApiKey:'AIzaSyAH19Yudd2ZaYzIdJednNVqnUX7ktSQptw',
      initialView: 'dayGridMonth',　// オプション　（月表示）
      locale: 'ja',
      buttonText: {
          today: '今日',
      },
      eventSources: [
            {
                googleCalendarId: '3u33dlvrhhdm7d6vrccu01j6ro@group.calendar.google.com',
            },
            {
                googleCalendarId: '0qik9nt8ugve9v3o9s8q2qbp74@group.calendar.google.com',
                className: 'ca_shipment'
            },
          {
            //日本の祝日カレンダー
            googleCalendarId: 'ja.japanese#holiday@group.v.calendar.google.com'
          }
        ]
      
    });
    calendar.render();
});

//baseTitle
$(window).on('scroll',function(){
  $(".line").each(function(){
    let position = $(this).offset().top;
    let scroll = $(window).scrollTop();
    let windowHeight = $(window).height();
    if (scroll > position - windowHeight + 180){
      $(this).addClass('active');
    }
  });
});

$(window).on('scroll',function(){
  $(".fadein").each(function(){
    let position = $(this).offset().top;
    let scroll = $(window).scrollTop();
    let windowHeight = $(window).height();
    if (scroll > position - windowHeight + 180){
      $(this).addClass('active');
    }
  });
});

//Pagetop
$(function() {
    var topBtn = $('#page-top');    
    topBtn.hide();
    //スクロールが100に達したらボタン表示
    $(window).scroll(function () {
        if ($(this).scrollTop() > 100) {
            topBtn.fadeIn();
        } else {
            topBtn.fadeOut();
        }
    });
    //スクロールしてトップ
    topBtn.click(function () {
        $('body,html').animate({
            scrollTop: 0
        }, 500);
        return false;
    });
});

//header追従
$(function() {
    var topBtn = $('#shop-header');    
    $(window).scroll(function () {
        if ($(this).scrollTop() > 40) {
            $("#shop-header").addClass("fixed");
        } else {
            $('#shop-header').removeClass('fixed');
        }
    });
});
